import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { MdLockOpen } from 'react-icons/md';

import {
  Container,
  ModalContainer,
  ModalHeader,
  ModalFooter,
  ButtonModal,
} from './styles';

const ModalPedidoReaberturaComp = ({
  modalIsVisible,
  setModalIsVisible,
  enviaPedidoReabertura,
}) => {
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = () => {
    enviaPedidoReabertura();
  };
  const handleCancel = () => {
    setModalIsVisible(false);
  };

  return (
    <Container>
      <Modal
        visible={modalIsVisible}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        cancelText="Conferir depois"
        centered
        footer={null}
        closable={null}
        width="480px"
      >
        <ModalContainer>
          <ModalHeader>
            <div className="iconModal">
              <span>
                <MdLockOpen size={30} />
              </span>
            </div>
            <h2>
              Confirmar <span> pedido de reabertura de competência </span>
            </h2>
          </ModalHeader>
          <div className="ModalBody">
            <div>
              <span>ATENÇÃO!</span>
              <p>
                A reabertura de uma competência excluirá os registros
                pré-existentes para o mês correspondente. Deseja continuar?
              </p>
            </div>
          </div>
        </ModalContainer>

        <ModalFooter>
          <ButtonModal type="button" onClick={handleOk}>
            {confirmLoading ? ' Enviando...' : 'OK'}
          </ButtonModal>
          <ButtonModal type="button" cancel onClick={handleCancel}>
            Cancelar
          </ButtonModal>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

ModalPedidoReaberturaComp.propTypes = {
  modalIsVisible: PropTypes.bool,
  setModalConfirma: PropTypes.func,
  setModalIsVisible: PropTypes.func.isRequired,
};

ModalPedidoReaberturaComp.defaultProps = {
  modalIsVisible: null,
  setModalConfirma: null,
};

export default ModalPedidoReaberturaComp;
